














































































import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import Checkbox from '@/modules/shared/components/shared/kit/Checkbox.vue'
import Radio from '@/modules/shared/components/shared/kit/Radio.vue'
import { mixins } from 'vue-class-component'
import DialogMixin from '@/modules/common/dialog/mixins/DialogMixin'
import CampaignItemPaymentStatusView
  from '@/modules/campaign-item-payment/components/shared/CampaignItemPaymentStatusView.vue'
import DateTooltipped from '@/modules/shared/components/shared/utils/DateTooltipped.vue'
import AdminUserInfoButton from '@/modules/user/components/admin/AdminUserInfoButton.vue'
import CampaignItemPaymentItemTypeView
  from '@/modules/campaign-item-payment/components/shared/CampaignItemPaymentItemTypeView.vue'
import CampaignItemPaymentTypeView
  from '@/modules/campaign-item-payment/components/shared/CampaignItemPaymentTypeView.vue'
import PriceView from '@/modules/shared/components/shared/PriceView.vue'
import {
  InvoiceCollectionModelDefault,
  InvoiceCollectionWithModelDefault
} from '@/modules/invoice/models/invoice-collection.model'
import InvoiceStatusView from '@/modules/invoice/components/shared/InvoiceStatusView.vue'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsisOld.vue'
import InvoicePersonTypeView from '@/modules/invoice/components/shared/InvoicePersonTypeView.vue'


@Component({
  components: {
    InvoicePersonTypeView,
    TextEllipsis,
    InvoiceStatusView,
    PriceView,
    CampaignItemPaymentTypeView,
    CampaignItemPaymentItemTypeView,
    AdminUserInfoButton,
    CampaignItemPaymentStatusView,
    BaseButton,
    Modal,
    Checkbox,
    Radio,
    DateTooltipped
  }
})
export default class PanelInvoiceInfoDialog extends mixins<DialogMixin>(DialogMixin) {

  @Prop() invoice!: InvoiceCollectionModelDefault
  @Prop() withData!: InvoiceCollectionWithModelDefault
  @Prop({ default: 'اطلاعات آیتم فاکتور' }) label: string
  private dialogModel: boolean = false
  private labelName = {
    id: 'شماره فاکتور',
    title: 'عنوان فاکتور',
    status: 'وضعیت',
    payable: 'مبلغ',
    discount: 'تخفیف کل',
    tax: 'مالیات',
    net_payable: 'پرداخت شده',
    person_type: 'نوع فاکتور',
    paid_at: 'تاریخ پرداخت',
    due_date: 'تاریخ سررسید',
    description: 'توضیحات'
  }

  show() {
    this.dialogModel = true
  }

}
